import Colors from '../util/BGColors';
import ConvertToHSL from '../util/RGB2HSL';
import axiosRetry from 'axios-retry';
import DisplayAxiosError from '../util/DisplayAxiosError';
import axios from 'axios';
import { modelCardProps } from '../interfaces/modelcard';

const client = axios.create({ baseURL: process.env.SITE_ROOT });
axiosRetry(client, { retries: 15, retryDelay: () => 1500, retryCondition: () => true });

async function deleteAll(modelData, history, enqueueSnackbar) {
    let promises = []
    console.log(modelData);
    for (let i = 0; i < modelData.length; i++) {
        const model = modelData[i];
        console.log(model);
        const config = {
            withCredentials: true,
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        };
        promises.push(axios.delete(`/api/model/${model.publicID}`, config).catch(error => DisplayAxiosError(error, enqueueSnackbar)));
    }

    await Promise.all(promises);

    history.push({
        pathname: '/',
        state: { message: 'Your models were deleted 💀' }
    })
}

function GetColor(ColorIndex){
    let bgcol = Colors.Solid[ColorIndex]

    // @ts-ignore
    var col: hsl = ConvertToHSL(bgcol.one);
    col.l = '15%';
    bgcol.two = `hsl(${col.h}, ${col.s}, ${col.l})`;
    return bgcol;
}

async function OldBulkEditOrbit(models: modelCardProps[], setOrbitOpen, setAutoTagLoading, bgcol) {
    //close orbit setter + open loading menu
    // @ts-ignore
    const orbit = document.querySelector('model-viewer#positioner').getCameraOrbit();
    setOrbitOpen(false);
    setAutoTagLoading(true);

    let autoTagPromises = []
    let waitForPreviewPromises = []
    for (let i = 0; i < models.length; i++) {
        const model = models[i];

        const editData = {
            Title: model.title,
            Description: '',
            Category: 0,
            ModelStyle: 0,
            Tags: [],
            BGData: { color: { one: bgcol.one, two: bgcol.two }, type: 'Radial' },
            Orbit: { theta: orbit.theta, phi: orbit.phi, radius: '100%' }
        }

        console.log(editData);

        await axios.post(`/api/model/${model.publicID}/edit`, { data: editData }, { withCredentials: true });
        await sleep(750);

        //push promises for auto tag in parallell
        autoTagPromises.push(client.post(`/api/model/${model.publicID}/autoTag`, { withCredentials: true }));

        //use axios retry to see when thumbnails are done cooking
        waitForPreviewPromises.push(client.head(`/api/static/${model.previewUrl.split('/')[3]}`).catch(() => {})); //something fucky is going on here - these seem to cascade on error and like spam the server lol
    }

    //Keep retrying image urls until they work
    await Promise.all(waitForPreviewPromises);

    //tag everything
    console.log('start autotag')
    await Promise.allSettled(autoTagPromises);

    //todo nav to bulk edit view
    //location.reload();
    window.location.search += '?bulkEdit';
}

async function BulkEditOrbit(listID: string, setOrbitOpen, setAutoTagLoading, bgcol) {
    //close orbit setter + open loading menu
    // @ts-ignore
    const orbit = document.querySelector("model-viewer#positioner").getCameraOrbit();
    setOrbitOpen(false);
    setAutoTagLoading(true);

    await axios.post(`/api/list/${listID}/setOrbitsAndTag`, {
        BGData: { color: { one: bgcol.one, two: bgcol.two }, type: 'Radial' },
        Orbit: { theta: orbit.theta, phi: orbit.phi, radius: '100%' }
    })

    //Ping the server for max 5 minutes to see if the job is done
    let i = 0;
    let interval = setInterval(async () => {
        const data = await axios.get(`/api/list/${listID}/checkBulkOrbitRunning`);
        if (data.data.running === false) {
            clearInterval(interval);
            setAutoTagLoading(false);
            window.location.search += '?bulkEdit';
        } else if (i > 60) {
            clearInterval(interval);
            setAutoTagLoading(false);
            window.location.search += '?bulkEdit';
        }
        i++;
    }, 5000);
}

async function SubmitEdits(data, enqueueSnackbar, history, listID, featuredIndex, bundleData) {

    //Check category is set 
    if (data.Category === 0) {
        enqueueSnackbar('Please select a category', { variant: 'error' });
        return;
    }

    let promises = []
    for (let i = 0; i < data.length; i++) {
        const model = data[i];
    
        const editData = {
            Title: model.Title,
            Description: model.Description,
            Category: model.Category,
            Tags: model.Tags,
        }

        //you done goofed, server sends catagory as the full string while it takes an index. If this isn't changed it will send a string back and chuck a hissy
        //client only sends an index if it's changed. If not it will send back the full string
        //hacky solution is to just yeet catagory if it wasn't changed
        if(typeof editData.Category === 'string') delete editData.Category; 

        promises.push(axios.post(`/api/model/${model.PublicID}/edit`, { data: editData }, { withCredentials: true }).catch((error) => {}));
    }

    //Actual list edit
    //strip ids from data to set list state + push name and list contents to server
    let mids = []
    data.map(m => mids.push(m.PublicID));
    promises.push(axios.post(`/api/list/${listID}`, { Models: mids, FeaturedAsset: mids[featuredIndex], ...bundleData}));

    Promise.allSettled(promises).then(async () => {
        await sleep(250); //wait for the server to catch up to the updated info
        history.push('/l/' + listID)
    });
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


interface hsl {
    h: string,
    s: string,
    l: string,
}

export {BulkEditOrbit, deleteAll, GetColor, SubmitEdits}